import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { activateEmail } from '../../store/ducks/activate-email';
import { closeWebview } from '../../store/ducks/shared';
import Icon, { NAMES } from '@ifit/react-icons';
import MuiRaisedButton from 'material-ui/RaisedButton';
import { TextField as MuiTextField } from 'redux-form-material-ui';
import { shark, scienceBlue } from '../../theme/colors';
import classNames from 'classnames';
import styles from '../../shared-styles';

import './index.css';

const emailRegex = /^[^@^\s]+@[^@^\s]+\.[^@^\s]+$/;

const validate = (values) => {
  const errors = {};
  if (!values.email || !emailRegex.test(values.email)) errors.email = 'Valid email required.';
  return errors;
};

export class ActivateEmailPage extends Component {
  render() {
    return (
      <div className={ classNames('activate-email-form', this.props.mediaType) }>
        <Icon
          name={ NAMES.ARROW_LEFT }
          color={ shark }
          size={ 24 }
          unitSize="px"
          onClick={ this.props.exit }
        />
        <form onSubmit={ this.props.handleSubmit }>
          <h1>To get started, enter your email.</h1>
          <Field
            name="email"
            component={ MuiTextField }
            className="email-field"
            hintText="Enter your email"
            floatingLabelText="Email address"
            fullWidth={ true }
            errorStyle={ styles.errorStyle }
            errorText={ this.props.errorText }
            inputStyle={ styles.textStyle }
            type="email"
            hintStyle={ styles.textStyle }
            floatingLabelStyle={ this.props.errorText ? { ...styles.textStyle, ...styles.errorStyle } : styles.textStyle }
            floatingLabelFocusStyle={{ color: scienceBlue }}
            underlineFocusStyle={{ borderColor: scienceBlue }}
            autoCapitalize="off"
            autoCorrect="off"
            disabled={ this.props.submitting }
            autoFocus
          />
          <MuiRaisedButton
            className="button"
            type="submit"
            label="Begin My Journey"
            primary={ true }
            fullWidth={ true }
            style={ styles.buttonStyle }
            buttonStyle={ styles.buttonBorderStyle }
            labelStyle={ styles.buttonLabelStyle }
            disabled={ this.props.submitting }
          />
          { !this.props.submitting && this.props.error
            ? <p className="error-text">{ this.props.error }</p>
            : null
          }
        </form>
      </div>
    );
  }
}

ActivateEmailPage.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  exit: PropTypes.func.isRequired,
  error: PropTypes.any,
  errorText: PropTypes.string,
  dirty: PropTypes.bool,
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
  mediaType: PropTypes.string
};

export default connect(
  state => ({
    mediaType: state.config.mediaType,
    error: state.activateEmail.error
  }),
  dispatch => ({
    exit: () => {
      dispatch(closeWebview());
    }
  })
)(
  reduxForm({
    form: 'activateEmail',
    validate,
    onSubmit: async ({ email }, dispatch) => {
      await dispatch(activateEmail(email));
    }
  })(ActivateEmailPage)
);
